import styled, { css } from "styled-components"

const ClickArea = styled.div`
  ${props =>
    props.$canClick
      ? css`
          cursor: pointer;
        `
      : ``}
`

export default ClickArea
